export const reportingIntro = {
  heading: "Reporting",
  intro: `This section will explain ho to create a report from annotations on a project.  Reports are created using annotations on a project.`,
};
